export const MULTI_VALUED_LIST_MORE_DROPDOWN_STYLES = {
  maxWidth: 320,
  minHeight: 120,
  minWidth: 320,
}
